/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable no-unused-vars */
import React, {useEffect, useId, useState, useRef} from 'react';
import css from './Blogger.module.scss';
import classNames from 'classnames';
import {useStore} from '../../../../../../store/store';
import {observer} from 'mobx-react';
import numeral from 'numeral';
import moment from 'moment';
import Navigation from '../../../../../modules/NavigationBloggers';
import imagePlug from '../../../../../../_metronic/assets/media/user.png';
import Card from '../../../../../shared/Card';
import {Button} from '../../../../../shared/Buttons';
import {formatNumberToCash, formatNumber2} from '../../../../../functions/formatNumber';
import {formateImage} from '../../../../../functions/formatImage';

const Header = ({
  page,
  setPage,
  data,
  id,
  links = [
    {link: 'stream', title: 'Потоки'},
    {link: 'settings', title: 'Настройки'},
    {link: 'analiz', title: 'Анализ Трафика'},
  ],
  settingData,
  setSettingData,
  saveSetting,
  setSaveButtonState,
  saveButtonState,
}) => {
  const avatarId = useId();
  const store = useStore();

  const time = useRef(null);
  const intervalId = useRef(null);
  const [timeInfo, setTimeInfo] = useState('');

  const [image, setImage] = useState('');

  useEffect(() => {
    if (!!settingData.avatar) {
      if (typeof settingData.avatar === 'object' && !!settingData.avatar) {
        formateImage(settingData.avatar[0], setImage);
      } else {
        return formateImage(settingData.avatar, setImage);
      }
    } else {
      formateImage('', setImage);
    }
  }, [settingData]);

  const formatTimeAgo = (milliseconds) => {
    if (new Date().getTime() - milliseconds * 1000 < 3600000) {
      return moment(milliseconds * 1000)
        .startOf('minute')
        .fromNow();
    }

    return moment(milliseconds * 1000)
      .startOf('hour')
      .fromNow();
  };

  useEffect(() => {
    getNewTime(!!data.updated_at ? data.updated_at * 1000 : data.created_at * 1000);
  }, [data]);

  const getNewTime = (miliss = 0) => {
    const newTime = miliss || new Date().getTime();
    time.current = newTime;

    if (intervalId.current) {
      clearInterval(intervalId.current);
    }

    intervalId.current = setInterval(() => {
      setTimeInfo(formatTimeAgo(time.current / 1000));
    }, 1000);

    setSaveButtonState(0);
  };

  useEffect(() => {
    if (saveButtonState === 1) {
      clearInterval(intervalId.current);
      time.current = null;
    }
  }, [saveButtonState]);

  return (
    <>
      <div className='card mb-8' id='bloggerHeader'>
        <div className='card-body p-5 pb-0'>
          <div className={css.header}>
            {page !== 'settings' && (
              <div
                className={css.avatar}
                style={{
                  backgroundImage: !!data?.avatar
                    ? `url(${process.env.REACT_APP_API_HOST}/${data?.avatar})`
                    : `url(${imagePlug})`,
                }}
              />
            )}
            {page === 'settings' && (
              <label
                className={classNames(css.avatar, css._edit)}
                style={{backgroundImage: image}}
                htmlFor={avatarId}
              >
                <input
                  type='file'
                  name='avatar'
                  id={avatarId}
                  accept='.png, .jpg, .jpeg .webp .gif'
                  onChange={(e) => {
                    setSaveButtonState(1);
                    setSettingData((prev) => ({...prev, avatar: e.target.files}));
                  }}
                />
              </label>
            )}
            <section className={css.bloggerData}>
              <div className={css.nameContainer}>
                <span className='text-gray-800 fs-2 fw-bold'>{data.name}</span>
              </div>
              <div className={css.otherData}>
                <div className='fw-semibold fs-5 text-gray-400'>#{id}</div>
                <span className={`badge badge-light-${data?.indicator?.indicator} me-auto`}>
                  {!store.roles.includes(19) ? `${formatNumber2(data?.romi)}%` : data?.indicator?.name}
                </span>
              </div>
            </section>
            <section className={css.metrics}>
              {!store.roles.includes(19) && (
                <div className='border border-gray-300 border-dashed rounded min-w-125px py-2 px-2 '>
                  <div className='d-flex align-items-center'>
                    {+data?.profit < 0 && (
                      <i className='ki-duotone ki-arrow-down fs-3 text-danger me-2'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                    )}
                    {+data?.profit >= 0 && (
                      <i className='ki-duotone ki-arrow-up fs-3 text-success me-2'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                    )}
                    <div className='fs-4 fw-bold'>{formatNumberToCash(data?.profit)}</div>
                  </div>

                  <div className='fw-semibold fs-6 text-gray-400'>Прибыль</div>
                </div>
              )}
              {!store.roles.includes(19) && (
                <div className='border border-gray-300 border-dashed rounded min-w-125px py-2 px-2 '>
                  <div className='d-flex align-items-center'>
                    <i className='ki-duotone ki-arrow-up fs-3 text-success me-2'>
                      <span className='path1'></span>
                      <span className='path2'></span>
                    </i>
                    <div className='fs-4 fw-bold'>{formatNumberToCash(data?.revenue)}</div>
                  </div>

                  <div className='fw-semibold fs-6 text-gray-400'>Доход</div>
                </div>
              )}
              <div className='border border-gray-300 border-dashed rounded min-w-125px py-2 px-2'>
                <div className='d-flex align-items-center'>
                  <i className='ki-duotone ki-arrow-down fs-3 text-danger me-2'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                  </i>
                  <div className='fs-4 fw-bold' data-kt-countup='true' data-kt-countup-value='75'>
                    {formatNumberToCash(data?.cost)}
                  </div>
                </div>

                <div className='fw-semibold fs-6 text-gray-400'>Расходы</div>
              </div>
            </section>
            <section className={css.actions}>
              <div className={css.row}>
                <div className={css.socialNetworks}>
                  {data?.instagram_link && (
                    <a
                      className={classNames(css.instagram, 'bg-light')}
                      href={data?.instagram_link}
                      target='blank'
                    >
                      <i className='bi bi-instagram fs-2'></i>
                    </a>
                  )}
                  {data?.youtube_link && (
                    <a
                      className={classNames(css.youtube, 'bg-light')}
                      href={data?.youtube_link}
                      target='blank'
                    ></a>
                  )}
                </div>
                {saveButtonState === 0 && (
                  <>
                    <Button
                      className='text-gray-500'
                      color={'btn-light'}
                      disabled={true}
                      action={async () => {
                        // save();
                      }}
                    >
                      Сохранено
                    </Button>
                  </>
                )}
                {saveButtonState === 1 && (
                  <>
                    <Button
                      action={async () => {
                        // save();
                        saveSetting();
                      }}
                    >
                      Сохранить
                    </Button>
                  </>
                )}
              </div>
              <div className={css.row}>
                {saveButtonState === 0 && timeInfo && (
                  <>
                    {!!data?.updated_at && (
                      <span className='text-gray-500'>Обновлено {timeInfo}</span>
                    )}
                    {!data?.updated_at && <span className='text-gray-500'>Создано {timeInfo}</span>}
                  </>
                )}
                {saveButtonState === 1 && (
                  <span className='text-gray-500'>Изменения не сохранены</span>
                )}
              </div>
            </section>
          </div>

          <div className='separator'></div>
          <Navigation page={page} setPage={setPage} links={links} />
        </div>
      </div>
    </>
  );
};

export default observer(Header);
